import { Viewer } from '@xeokit/xeokit-sdk';
import { Storey } from '@xeovision/storey-views-plugin';

export function detectFarAwayObjects(
  viewer: Viewer,
  storeys: { [storeyId: string]: Storey },
): {
  hasObjectsFarAway: boolean;
  modelsDiagonals: { [modelId: string]: { diagonal: number; hasObjectsFarAway: boolean } };
  modelStoreysDiagonals: { [modelId: string]: number[] };
} {
  console.log('Detecting far away objects...');
  const t0 = performance.now();
  const modelsDiagonals: { [modelId: string]: { diagonal: number; hasObjectsFarAway: boolean } } =
    {};
  const modelStoreysDiagonals: { [modelId: string]: number[] } = {};

  Object.keys(viewer.scene.models).forEach((modelId) => {
    const model = viewer.scene.models[modelId];
    if (model) {
      const modelDiagonal = getAABB3DDiagonalFromArray(model.aabb);

      modelsDiagonals[modelId] = { diagonal: modelDiagonal, hasObjectsFarAway: false };
    }
  });

  if (Object.keys(storeys).length) {
    Object.keys(storeys).forEach((storeyId) => {
      const storey = storeys[storeyId];
      if (storey) {
        const storeyDiagonal = getAABB3DDiagonalFromArray(storey.storeyAABB);

        if (!modelStoreysDiagonals[storey.modelId]) {
          modelStoreysDiagonals[storey.modelId] = [];
        }

        modelStoreysDiagonals[storey.modelId].push(storeyDiagonal);
      }
    });
  }

  let hasObjectsFarAway = false;

  Object.keys(modelStoreysDiagonals).forEach((modelId) => {
    const modelDiagonal = modelsDiagonals[modelId].diagonal;

    const averangeStoreyDiagonal =
      modelStoreysDiagonals[modelId].reduce((acc, diagonal) => acc + diagonal, 0) /
      modelStoreysDiagonals[modelId].length;

    const factor = 10;

    const check = averangeStoreyDiagonal * factor < modelDiagonal;

    // Check if the average storey diagonal is more than 10 times smaller than the model diagonal
    if (check) {
      hasObjectsFarAway = true;
    }

    console.log(
      `Model ${modelId} average storey diagonal length: ${averangeStoreyDiagonal}, model diagonal length: ${modelDiagonal}, factor: ${factor} ====>`,
      check ? 'FAR AWAY' : 'CLOSE',
    );
  });

  const t1 = performance.now();
  console.log(`Far away objects detection took ${t1 - t0} ms`);

  return { hasObjectsFarAway, modelsDiagonals, modelStoreysDiagonals };
}

function getAABB3DDiagonalFromArray(aabbArray: number[]): number {
  const minX = aabbArray[0];
  const minY = aabbArray[1];
  const minZ = aabbArray[2];
  const maxX = aabbArray[3];
  const maxY = aabbArray[4];
  const maxZ = aabbArray[5];

  const width = maxX - minX;
  const height = maxY - minY;
  const depth = maxZ - minZ;

  // Using Math.abs in case min > max, though for a canonical AABB this isn't strictly needed.
  const absWidth = Math.abs(width);
  const absHeight = Math.abs(height);
  const absDepth = Math.abs(depth);

  const diagonalLength = Math.sqrt(
    absWidth * absWidth + absHeight * absHeight + absDepth * absDepth,
  );

  return diagonalLength;
}
